module.exports = __webpack_public_path__ + "static/media/22861830_1638433482898503_979588159861682434_o-thumb.79027625.jpg";